export function getAll() {
  return [
    {
      value: 0,
      name: "All",
      text: "全部",
    },
    {
      value: 1,
      name: "UnConfirmed",
      text: "未確認",
    },
    {
      value: 2,
      name: "Confirmed",
      text: "已確認",
    },
    {
      value: 3,
      name: "Void",
      text: "作廢",
    },
  ];
}
